<template>
  <div class="home">
    <div class="top">
      <div class="top_btn" @click="Myclick()">查看我的奖品</div>
      <div class="top_btn" @click="Rule()">规则说明</div>
    </div>
    <div class="text">解锁宝箱机会剩余{{ info.chance_num }}次</div>
    <!-- 暮鼓 -->
    <!-- 1635696000   1635696000  -->
    <img
      class="mg img"
      @click="click('1', 1635696000, 1635868800)"
      :src="img1"
      alt=""
    />
    <!-- 华山 -->
    <!-- 1635955200  1636128000-->
    <img
      class="hs img"
      @click="click('2', 1635955200, 1636128000)"
      :src="img2"
      alt=""
    />
    <!-- 宝塔 -->
    <!-- 1636214400  1636473600-->
    <img
      class="bt img"
      @click="click('3', 1636214400, 1636473600)"
      :src="img3"
      alt=""
    />
    <!-- 宝箱 -->
    <img class="bx img" @click="synthesis()" :src="img7" alt="" />
    <!-- 合成 -->
    <img class="hc btn" :src="img5" @click="synthesis()" alt="" />
    <!-- 分享 -->
    <img class="fx btn" @click="share()" :src="img6" alt="" />
    <Mod
      :info="prize"
      v-show="isshow"
      :type="type"
      @transfer="getUser"
      @synthesis="aggregate"
      :fx="fx"
    ></Mod>
    <!--Mod 合成 抽奖弹框  -->
    <!-- my 我的奖品 -->
    <My v-show="myshow" :info="info" @transfer="Myclick"></My>
    <!-- Rule 活动规则 -->
    <Rule v-show="ruleshow" @transfer="Ruleclick"></Rule>
    <div class="gzbox" @click="gzbox" v-show="gzimg">
      <img :src="img.img48" class="gzimg" alt="" />
      <div class="qx">X</div>
    </div>
  </div>
</template>

<script>
import { md5 } from "@/utils/md5.js";
import { keysort, getstring, config, browser } from "@/utils/common.js";
import img from "@/utils/img.js";
import weiXinShare from "@/utils/share.js";
import Mod from "@/components/Mod.vue";
import My from "@/components/My.vue";
import Rule from "@/components/Rule.vue";
import { Toast } from "vant";
// Dialog
import {
  treasure_index,
  treasure_get_chance,
  treasure_draw_card,
  member_id_login, //用户信息
  c_coupon11, //领取关卡优惠券
  c_card11, //领取合成卡
  c_compose11, //集齐3张卡后合
  c_final_coupon11, //领取合成后的优惠券
  c_view11, //浏览活动页面
} from "@/api/index";
export default {
  name: "Home",
  components: {
    Mod, //弹窗组件
    My, //
    Rule,
  },
  data() {
    return {
      img,
      img1: img.img47, //暮鼓
      img2: img.img2, //华山
      img3: img.img1, //宝塔
      img4: img.img6, //已解锁
      img5: img.img4, //去合成
      img6: img.img3, //分享
      img7: img.img30, //11宝箱
      isshow: false, //mod弹窗
      type: false, //奖品弹窗||合成弹窗
      myshow: false, //奖品弹窗
      ruleshow: false, //规则弹窗
      info: {}, //首页数据
      prize: "", //抽出的奖励
      session: "", //登录sessios
      member_id: "", //member_id
      fx: false, //分享引导
      loading: true,
      gzimg: false, //规则图片
    };
  },
  computed: {},
  // 创建前
  beforeCreate: function () {},
  // 创建后
  created: function () {
    this.nowTimes(); //获取当前时间
    this.$route.query;
    // console.log(this.$route.query);

    window.sessionStorage.setItem(
      "member_id",
      decodeURIComponent(this.$route.query.member_id)
    );

    if (document.cookie.indexOf("S[MEMBER]=") != -1) {
      window.sessionStorage.setItem("member_id", this.getCookie("S[MEMBER]="));
    }

    window.sessionStorage.setItem(
      "session",
      decodeURIComponent(this.$route.query.session)
    );
    window.sessionStorage.setItem(
      "openid",
      decodeURIComponent(this.$route.query.openid)
    );

    if (this.$route.query.app == 1) {
      window.sessionStorage.setItem("source_name", "怡康到家小程序");
      window.sessionStorage.setItem("source", "小程序");
    } else if (this.$route.query.app == 2) {
      window.sessionStorage.setItem("source_name", "怡康优选小程序");
      window.sessionStorage.setItem("source", "小程序");
    } else {
      console.log("其他路径");
      window.sessionStorage.setItem("source_name", "app");
      window.sessionStorage.setItem("source", "app");
    }
    this.member_id_login(); //获取用户信息
  },
  activated: function () {},
  // 挂载前
  beforeMount: function () {},
  // 挂载后
  mounted: function () {
    if (window.name == "") {
      console.log("首次被加载");
      window.name = "isReload"; // 在首次进入页面时我们可以给window.name设置一个固定值
      this.gzimg = true;
    } else if (window.name == "isReload") {
      console.log("页面被刷新");
      this.gzimg = false;
    }
  },

  // 更新前
  beforeUpdate: function () {},
  // 更新完成
  updated: function () {},
  methods: {
    // 获取cookie
    getCookie(name) {
      var cookies = document.cookie.split(name);
      let member_id = cookies[1].split(";")[0];
      return member_id;
    },

    // 规则
    gzbox() {
      this.gzimg = false;
    },
    // 获取用户信息
    async member_id_login() {
      let params = {
        timestamp: Date.parse(new Date()) / 1000,
        member_id: window.sessionStorage.getItem("member_id"),
        appid: config.appid,
      };
      const sign = md5(getstring(keysort(params)));
      params = {
        ...params,
        sign,
      };
      const { data } = await member_id_login(params);
      console.log(data, "用户信息");
      // this.info = data.info;
      if (data.result == "success") {
        window.sessionStorage.setItem(
          "member_id",
          decodeURIComponent(data.info.member.id)
        );
        window.sessionStorage.setItem(
          "session",
          decodeURIComponent(data.info.session)
        );
        window.sessionStorage.setItem(
          "mobile",
          decodeURIComponent(data.info.member.mobile)
        );
        c_view11("寻宝活动首页", "https://huodong.yaoking.cn/#/");
        this.treasure_index();
      } else {
        // Toast.fail(data.msg);
        Toast.fail(data.msg);
      }
    },
    // 点击景点
    click(type, startTime, endTime) {
      if (this.info.draw_disabled != true) {
        let cookie = this.getCookie("member_id");
        Toast.fail(cookie);
        return false;
      }
      var nowTime = Date.parse(new Date()) / 1000; //当前时间
      console.info(startTime, endTime, nowTime, "时间戳");
      // 判断当前时间是否大于活动设置的开始时间，并且当前的设备时间是小于等于活动设置的结束时间
      // && nowTime <= endTime

      if (nowTime >= startTime) {
        console.info("活动进行中");
        this.$router.push({
          path: "/about",
          query: {
            type: type,
          },
        });
        // 判断当前设备时间是否大于活动设置的结束时间
      }
      //  if (nowTime >= endTime) {
      //   console.info("活动已经结束");
      //   // 其余的都是未开始
      // } else
      else {
        Toast.fail("活动未开始!!");
        console.info("活动未开始");
      }
    },
    // 分享朋友圈
    share() {
      if (browser.versions.mobile) {
        //判断是否是移动设备打开
        var ua = navigator.userAgent.toLowerCase(); //获取判断用的对象
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          //在微信中打开
          console.log("微信");
          this.fx = true;
          this.isshow = true;
        }
        if (browser.versions.ios) {
          // var url = location.href.split("#")[0];
          console.log("ios");
          let dataForWeixin = {
            title: "双十一寻宝活动", //分享标题
            desc: "双十一寻宝活动", //分享内容
            linkurl: "https://huodong.yaoking.cn/index.html#/?hdxb", //分享链接
            img: "", //分享内容显示的图片(图片必须是正方形的链接)
          };
          weiXinShare.getJSSDK(dataForWeixin);
        }
        if (browser.versions.android) {
          // var azurl = location.href.split("#")[0];
          console.log("安卓");
          let dataForWeixin = {
            title: "双十一寻宝活动", //分享标题
            desc: "双十一寻宝活动", //分享内容
            linkurl: "https://huodong.yaoking.cn/index.html#/?hdxb", //分享链接
            img: "", //分享内容显示的图片(图片必须是正方形的链接)
          };
          weiXinShare.getJSSDK(dataForWeixin);
        }
      } else {
        //否则就是PC浏览器打开
        // console.log("pc");
        // Dialog.confirm({
        //   title: "标题",
        //   message: "请在app或者小程序中参与活动",
        //   width: "80% ",
        // })
        //   .then(() => {
        //     // on confirm
        //   })
        //   .catch(() => {
        //     // on cancel
        //   });
        let dataForWeixin = {
          title: "双十一寻宝活动", //分享标题
          desc: "双十一寻宝活动", //分享内容
          linkurl: "https://huodong.yaoking.cn/index.html#/?hdxb", //分享链接
          img: "", //分享内容显示的图片(图片必须是正方形的链接)
        };
        weiXinShare.getJSSDK(dataForWeixin);
      }

      this.chance(2);
    },
    // 获取当前时间
    nowTimes() {
      let nowTime = Date.parse(new Date()) / 1000; //当前时间
      //     // 解锁暮鼓 1635955200
      if (1635696000 <= nowTime) {
        this.img1 = this.img.img7;
      }

      if (1635955200 <= nowTime) {
        this.img2 = this.img.img8;
      }
      // 解锁宝塔  1635955200
      if (1635955200 <= nowTime) {
        this.img3 = this.img.img9;
      }
      // 双十一晚八点开启终极大奖 1636560000
      if (nowTime >= 1636560000) {
        this.img5 = this.img.img5; //去合成
        this.img7 = this.img.img31; //去合成
      }
    },
    // 去合成
    synthesis() {
      let nowTime = Date.parse(new Date()) / 1000; //当前时间
      // 1636560000
      if (nowTime >= 1636560000 && this.info.draw_disabled) {
        this.fx = false;
        this.isshow = true;
        this.type = false;
      } else {
        console.log("活动时间未到");
        Toast("双十一晚八点开启终极大奖");
      }
    },
    // 首页数据
    async treasure_index() {
      let params = {
        member_id: window.sessionStorage.getItem("member_id"),
        timestamp: Date.parse(new Date()) / 1000,
        session: window.sessionStorage.getItem("session"),
        appid: config.appid,
      };
      const sign = md5(getstring(keysort(params)));
      params = {
        ...params,
        sign,
      };
      const { data } = await treasure_index(params);
      this.info = data.info;
    },
    // chance 分享 次数
    async chance(type) {
      //type  1打开，2分享
      let params = {
        member_id: window.sessionStorage.getItem("member_id"),
        timestamp: Date.parse(new Date()) / 1000,
        session: window.sessionStorage.getItem("session"),
        appid: config.appid,
        type: type,
      };
      const sign = md5(getstring(keysort(params)));
      params = {
        ...params,
        sign,
      };
      const { data } = await treasure_get_chance(params);
      console.log(data, "data");
      if (data.result == "success") {
        console.log("1");
      } else if (type == 2) {
        // console.log(data.msg)
        // Toast.fail(data.msg);
      }
      this.treasure_index(); //首页数据
    },
    // 调用子组件方法 立即领取
    getUser(v) {
      this.isshow = v;
      this.fx = false;
    },
    //调用子组件方法 立即合成
    async aggregate() {
      if (this.fx) {
        this.fx = false;
        this.isshow = false;
      } else {
        this.card(4); //景点标志   1大雁塔 2华山 3秦岭 4卡片合成
      }
    },
    // 抽奖
    async card(type) {
      let that = this;
      let params = {
        member_id: window.sessionStorage.getItem("member_id"),
        timestamp: Date.parse(new Date()) / 1000,
        session: window.sessionStorage.getItem("session"),
        appid: config.appid,
        type: type,
      };
      const sign = md5(getstring(keysort(params)));
      //  params.append("sign", sign);
      params = {
        ...params,
        sign,
      };
      let { data } = await treasure_draw_card(params);
      if (data.result == "success") {
        if (data) {
          // alert(data.msg);
          switch (Number(data.info.id)) {
            case 0:
              // 未抽中
              data.img = that.img.img20;
              data.btn = that.img.img23;
              data.text = "未获得奖励";
              break;
            case 1:
              // 未抽中
              data.img = that.img.img20;
              data.btn = that.img.img23;
              data.text = "未获得奖励";
              break;
            case 2:
              // 爱情卡
              data.img = that.img.img17;
              data.text = "恭喜抽中爱情卡";
              data.btn = that.img.img16;
              c_card11("爱情卡");
              break;
            case 3:
              // 黄芪精30元优惠券
              data.img = that.img.img33;
              data.text = "黄芪精30元优惠券";
              data.btn = that.img.img16;
              data.quna = true;
              c_coupon11("黄芪精30元优惠券", data.info.id);
              break;
            case 4:
              // 益安宁丸130元优惠券优惠券
              data.img = that.img.img35;
              data.text = "益安宁丸130元优惠券";
              data.btn = that.img.img16;
              // data.text = "恭喜获得优惠券一张";
              data.quna = true;
              // data.btn = that.img.img16;
              c_coupon11("益安宁丸130元优惠券", data.info.id);
              break;
            case 5:
              //东阿阿胶铁盒12元优惠券
              data.img = that.img.img32;
              data.text = "东阿阿胶铁盒12元优惠券";
              data.btn = that.img.img16;
              data.quna = true;
              c_coupon11("东阿阿胶铁盒12元优惠券", data.info.id);
              break;
            case 6:
              // 天然维生素C5元优惠券
              data.img = that.img.img34;
              data.text = "天然维生素C5元优惠券";
              data.btn = that.img.img16;
              data.quna = true;
              c_coupon11("天然维生素C5元优惠券", data.info.id);
              break;
            case 7:
              data.img = that.img.img20;
              data.btn = that.img.img23;
              data.text = "未获得奖励";
              break;
            case 8:
              // 恭喜抽中事业卡;
              data.img = that.img.img18;
              data.text = "恭喜抽中事业卡";
              data.btn = that.img.img16;
              c_card11("事业卡");
              break;
            case 9:
              // 复方阿胶浆20元优惠券
              data.img = that.img.img38;
              data.text = "复方阿胶浆20元优惠券";
              data.btn = that.img.img16;
              data.quna = true;
              c_coupon11("复方阿胶浆20元优惠券", data.info.id);
              break;
            case 10:
              //雅塑窦利司他胶装10元优惠券
              data.img = that.img.img37;
              data.text = "雅塑窦利司他胶装10元优惠券";
              data.btn = that.img.img16;
              data.quna = true;
              c_coupon11("雅塑窦利司他胶装10元优惠券", data.info.id);
              break;
            case 11:
              // 龙牡壮骨颖粒80元优惠券
              data.img = that.img.img36;
              data.text = "龙牡壮骨颖粒80元优惠券";
              data.btn = that.img.img16;
              data.quna = true;
              c_coupon11("龙牡壮骨颖粒80元优惠券", data.info.id);
              break;
            //
            case 12:
              //  汤臣倍健蛋白粉30元优惠券:
              data.img = that.img.img39;
              data.text = "汤臣倍健蛋白粉30元优惠券";
              data.btn = that.img.img16;
              data.quna = true;
              c_coupon11("汤臣倍健蛋白粉30元优惠券", data.info.id);
              break;
            case 13:
              data.img = that.img.img20;
              data.btn = that.img.img23;
              data.text = "未获得奖励";
              break;
            case 14:
              // 恭喜获得健康卡一张
              data.img = that.img.img19;
              data.btn = that.img.img16;
              data.text = "恭喜获得健康卡一张";
              c_card11("健康卡");
              break;
            case 15:
              // 米诺地尔酊10元优惠
              data.img = that.img.img42;
              data.text = "恭喜获得米诺地尔酊10元优惠一张";
              data.btn = that.img.img16;
              data.quna = true;
              c_coupon11("米诺地尔酊10元优惠", data.info.id);
              break;
            case 16:
              // 燕窝50优惠券
              data.text = "恭喜获得燕窝50元优惠券一张";
              data.btn = that.img.img16;
              data.img = that.img.img43;
              data.quna = true;
              c_coupon11("燕窝50元优惠券", data.info.id);
              break;
            case 17:
              // 肾宝片10元优惠券
              data.text = "恭喜获得肾宝片10元优惠券一张";
              data.btn = that.img.img16;
              data.img = that.img.img44;
              data.quna = true;
              c_coupon11("肾宝片10元优惠券", data.info.id);
              break;
            case 18:
              // 阿胶50优惠券
              data.text = "恭喜获得阿胶50元优惠券一张";
              data.btn = that.img.img16;
              data.img = that.img.img45;
              data.quna = true;
              c_coupon11("阿胶50优惠券优惠券", data.info.id);
              break;
            case 19:
              // 10通用优惠券
              data.text = "恭喜获得10元优惠券一张";
              data.btn = that.img.img16;
              data.img = that.img.img41;
              // data.quna = true;
              c_compose11("10通用优惠券");
              c_final_coupon11("10通用优惠券", data.info.id);
              break;
            case 20:
              // 1000
              data.img = that.img.img25;
              data.btn = that.img.img16;
              data.text = "恭喜获得1000元现金";
              c_compose11("1000元现金");
              c_final_coupon11("1000元现金", data.info.id);
              break;
            case 21:
              // 黄金转运珠
              data.img = that.img.img26;
              data.btn = that.img.img16;
              data.text = "恭喜获得黄金转运珠";
              c_compose11("黄金转运珠");
              c_final_coupon11("黄金转运珠", data.info.id);
              break;
            case 22:
              // 1000
              data.img = that.img.img27;
              data.btn = that.img.img16;
              data.text = "恭喜获得养生堂护手霜";
              c_compose11("养生堂护手霜");
              break;
            case 23:
              // 薇诺娜面膜礼盒
              data.img = that.img.img28;
              data.btn = that.img.img16;
              data.text = "恭喜获得薇诺娜面膜礼盒";
              c_compose11("薇诺娜面膜礼盒");
              c_final_coupon11("薇诺娜面膜礼盒", data.info.id);
              break;
            case 24:
              // 50通用优惠券
              data.text = "恭喜获得50元优惠券一张";
              data.btn = that.img.img16;
              data.img = that.img.img40;
              // data.quna = true;
              c_compose11("50元通用优惠券");
              c_final_coupon11("50元通用优惠券", data.info.id);
              break;
            default:
              console.log("谢谢参与");
              data.id = 0;
              data.img = that.img.img20;
              data.btn = that.img.img23;
              break;
          }
          that.prize = data;
          that.onshow = !that.onshow;
        } else {
          console.log(data);
        }
        this.type = true;
        this.treasure_index();
      } else {
        this.isshow = false;
        Toast.fail(data.msg);
      }
    },
    // 我的奖品
    Myclick() {
      this.myshow = !this.myshow;
    },
    //活动规则
    Rule() {
      this.ruleshow = !this.ruleshow;
    },
    Ruleclick() {
      this.ruleshow = !this.ruleshow;
    },
  },
};
</script>
<style scoped>
.gzbox {
  width: 80%;
  height: 80%;
  position: relative;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.gzimg {
  width: 100%;
}
.qx {
  color: #fff;
  font-size: 30px;
  border-radius: 50%;
  font-size: 0.8rem;
  border-radius: 50%;
  text-align: center;
  line-height: 40px;
  height: 40px;
  width: 40px;
  border: 2px solid #fff;
}
.home {
  width: 100%;
  height: 100vh;
  /* background: url("https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/bj-min.png"); */
  background-image: url(https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/bj-min.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
}
.top {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.top_btn {
  border-radius: 14px;
  padding: 6px 12px;
  background: #00000033;
  font-size: 14px;
  margin-top: 10px;
  margin-right: 10px;
  color: #fff;
}
.text {
  width: 80%;
  text-align: center;
  color: #8a2cfc;
  font-size: 14px;
  position: absolute;
  top: 27vh;
  left: 0;
  right: 0;
  margin: auto;
  font-weight: 600;
}
.img {
  width: 80px;
  height: 90px;
}
.btn {
  width: 70%;
  height: 50px;
  right: 0;
  left: 0;
  margin: auto;
}
.mg {
  /* 晨钟暮鼓 */
  position: absolute;
  top: 32vh;
  right: 10vh;
}
.hs {
  /* 华山 */
  position: absolute;
  top: 48vh;
  right: 1vh;
}
.bt {
  /*宝塔 */
  position: absolute;
  bottom: 25vh;
  left: 6vh;
}
.bx {
  /*宝箱 */
  position: absolute;
  bottom: 20vh;
  right: 1vh;
  width: 80px;
  height: 80px;
}
.hc {
  /* 合成 */
  position: absolute;
  bottom: 12vh;
}
.fx {
  /* 分享 */
  position: absolute;
  bottom: 5vh;
}
</style>